import { jsx as r } from "react/jsx-runtime";
function t(e) {
  return /* @__PURE__ */ r("svg", { fill: "none", height: "1em", viewBox: "0 0 24 24", width: "1em", ...e, children: /* @__PURE__ */ r(
    "path",
    {
      d: "M8.9141 12L17.207 3.707C17.5976 3.3164 17.5976 2.6836 17.207 2.2929C16.8164 1.9022 16.1836 1.9023 15.7929 2.2929L6.793 11.293C6.4024 11.6836 6.4024 12.3164 6.793 12.7071L15.793 21.7071C15.9883 21.9024 16.2442 22.0001 16.5 22.0001C16.7558 22.0001 17.0117 21.9024 17.207 21.7071C17.5976 21.3165 17.5976 20.6837 17.207 20.293L8.9141 12Z",
      fill: "currentColor"
    }
  ) });
}
export {
  t as default
};
